import { z } from "zod";

export const ContactSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(3, { message: "O nome deve ter no mínimo 3 caracteres." })
    .max(50, { message: "O nome deve ter no máximo 50 caracteres." }),
  lastName: z
    .string()
    .trim()
    .min(3, { message: "O sobrenome deve ter no mínimo 3 caracteres." })
    .max(50, { message: "O sobrenome deve ter no máximo 50 caracteres." }),
  phone: z
    .string()
    .trim()
    .regex(
      /^[+]?[\d\s().-]{10,15}$/,
      "O telefone deve conter apenas números e no máximo 15 caracteres."
    )
    .min(10, { message: "O telefone deve ter no mínimo 10 caracteres." })
    .max(15, { message: "O telefone deve ter no máximo 15 caracteres." }),
  email: z.string().trim().email({ message: "O e-mail deve ser válido." }),
  message: z
    .string()
    .trim()
    .max(500, { message: "A mensagem deve ter no máximo 500 caracteres." }),
});
